export default {
  List: {
    Title: "Nhóm tài sản",
    Search: "Tìm kiếm nhóm tài sản",
    AddButton: "Thêm nhóm tài sản",
    SearchPlaceHolder: "Nhập tên nhóm tài sản",
  },
  Detail: {
    Add: "Thêm mới nhóm tài sản",
    Edit: "Sửa nhóm tài sản",
    AssetCategoryCode: "Mã nhóm tài sản",
    AssetCategoryName: "Tên nhóm tài sản",
    AssetCategoryParent: "Thuộc nhóm",
    DeleteAlertParent: "Nhóm tài sản này đã có phát sinh Nhóm tài sản chi tiết. Bạn không thể xóa.",
    WarningInactive:
      "Bạn đang ngừng sử dụng nhóm tài sản cấp cha <{0}>, hệ thống sẽ tự động ngừng sử dụng tất cả các nhóm tài sản cấp con của <{0}>. Bạn có muốn tiếp tục thực hiện không?",
    WarningActive:
      'Bạn có muốn bỏ tích "Ngừng sử dụng" cho tất cả các nhóm tài sản cấp con của nhóm tài sản <{0}> không?',
    WarningWhenHasRiseWithInactive:
      "Nhóm tài sản <{0}> (hoặc các nhóm tài sản cấp con của nhóm <{0}>) đã có phát sinh loại tài sản. Bạn có chắc chắn muốn ngừng sử dụng không?",
    WarningSelectChildBecomeParent:
      "Bạn không thể chọn nhóm tải sản <{0}> vì đó là con của nhóm tài sản <{1}>. Vui lòng kiểm tra lại!",
    WarningSelectSeftBecomeParent:
      "Bạn không thể chọn nhóm tải sản <{0}> vì đó chính là nhóm đang sửa <{1}>. Vui lòng kiểm tra lại!",
    WarningWhenParentHasRise:
      "Nhóm tài sản <{0}> đã có phát sinh loại tài sản. Tất cả loại tài sản thuộc nhóm <{1}> sẽ được chuyển sang nhóm <{2}>. Bạn có muốn tiếp tục thực hiện không?",
    WarningWhenChildActive:
      "Nhóm tài sản cha đang ở trạng thái <Ngừng theo dõi>. Bạn không thể thiết lập trạng thái <theo dõi> cho nhóm tài sản con.",
  },
  Search: {
    Title: "Nhóm tài sản",
  },
};
